var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3541 4.64592C14.4006 4.69236 14.4376 4.74754 14.4628 4.80828C14.488 4.86903 14.501 4.93415 14.501 4.99992C14.501 5.06568 14.488 5.13081 14.4628 5.19155C14.4376 5.2523 14.4006 5.30747 14.3541 5.35392L8.35408 11.3539C8.30764 11.4005 8.25246 11.4374 8.19172 11.4626C8.13097 11.4878 8.06585 11.5008 8.00008 11.5008C7.93432 11.5008 7.8692 11.4878 7.80845 11.4626C7.7477 11.4374 7.69253 11.4005 7.64608 11.3539L1.64608 5.35392C1.5522 5.26003 1.49945 5.13269 1.49945 4.99992C1.49945 4.86714 1.5522 4.7398 1.64608 4.64592C1.73997 4.55203 1.86731 4.49928 2.00008 4.49928C2.13286 4.49928 2.2602 4.55203 2.35408 4.64592L8.00008 10.2929L13.6461 4.64592C13.6925 4.59935 13.7477 4.56241 13.8084 4.5372C13.8692 4.512 13.9343 4.49902 14.0001 4.49902C14.0659 4.49902 14.131 4.512 14.1917 4.5372C14.2525 4.56241 14.3076 4.59935 14.3541 4.64592Z",
    fill: "#FFFDF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/Chevron.0fa43a5ec8271e3e4904ddd31cd40568.svg";
export { ForwardRef as ReactComponent };